import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type RecordLearningWalkthroughOutcomeMutationVariables = Types.Exact<{
  conceptId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  walkthroughId: Types.Scalars['String']['input'];
  outcome: Types.LearningWalkthroughOutcome;
}>;


export type RecordLearningWalkthroughOutcomeMutation = { __typename?: 'Mutation', recordLearningWalkthroughOutcome: { __typename?: 'LearningWalkthroughOutcomePayload', walkthrough?: { __typename?: 'LearningWalkthroughState', walkthroughId: string, offeredAt?: Types.TDateISO | null, dismissedAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RecordLearningConceptExplainedMutationVariables = Types.Exact<{
  conceptId: Types.Scalars['String']['input'];
}>;


export type RecordLearningConceptExplainedMutation = { __typename?: 'Mutation', recordLearningConceptExplained: { __typename?: 'LearningConceptPayload', concept?: { __typename?: 'LearningConcept', conceptId: string, titleKey: string, summaryKey: string, docsPath: string, walkthroughId?: string | null, isComplete: boolean, milestone?: { __typename?: 'LearningMilestone', eventTypes: Array<string> } | null, progress: { __typename?: 'LearningConceptProgress', explainedAt?: Types.TDateISO | null, milestoneObservedAt?: Types.TDateISO | null } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const RecordLearningWalkthroughOutcomeDocument = new TypedDocumentString(`
    mutation RecordLearningWalkthroughOutcome($conceptId: String, $walkthroughId: String!, $outcome: LearningWalkthroughOutcome!) {
  recordLearningWalkthroughOutcome(
    conceptId: $conceptId
    walkthroughId: $walkthroughId
    outcome: $outcome
  ) {
    walkthrough {
      ...LearningWalkthroughState
    }
    errors {
      code
      message
    }
  }
}
    fragment LearningWalkthroughState on LearningWalkthroughState {
  walkthroughId
  offeredAt
  dismissedAt
}`);
export const RecordLearningConceptExplainedDocument = new TypedDocumentString(`
    mutation RecordLearningConceptExplained($conceptId: String!) {
  recordLearningConceptExplained(conceptId: $conceptId) {
    concept {
      ...LearningPathConcept
    }
    errors {
      code
      message
    }
  }
}
    fragment LearningPathConcept on LearningConcept {
  conceptId
  titleKey
  summaryKey
  docsPath
  walkthroughId
  isComplete
  milestone {
    eventTypes
  }
  progress {
    explainedAt
    milestoneObservedAt
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    RecordLearningWalkthroughOutcome: build.mutation<RecordLearningWalkthroughOutcomeMutation, RecordLearningWalkthroughOutcomeMutationVariables>({
      query: (variables) => ({ document: RecordLearningWalkthroughOutcomeDocument, variables })
    }),
    RecordLearningConceptExplained: build.mutation<RecordLearningConceptExplainedMutation, RecordLearningConceptExplainedMutationVariables>({
      query: (variables) => ({ document: RecordLearningConceptExplainedDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useRecordLearningWalkthroughOutcomeMutation, useRecordLearningConceptExplainedMutation } = injectedRtkApi;
